/** Activity type row fields needed to resolve a default checklist. */
export type ActivityTypeDefaultChecklistSource = {
  id: string;
  default_checklist_id?: string | null;
};

export function getDefaultChecklistIdForActivityType(
  activityTypes: ActivityTypeDefaultChecklistSource[],
  activityTypeKey: string,
): string | null {
  const key = String(activityTypeKey ?? '').trim();
  if (!key) return null;
  const match = activityTypes.find((t) => t.id === key);
  const id = String(match?.default_checklist_id ?? '').trim();
  return id || null;
}

/**
 * When the activity type changes, apply the new type's default checklist if the
 * current checklist is empty or still equals the previous type's default
 * (so a manual choice is not overwritten).
 */
export function nextChecklistIdForActivityTypeChange(
  activityTypes: ActivityTypeDefaultChecklistSource[],
  previousType: string,
  nextType: string,
  currentChecklistId: string | null | undefined,
): string | null {
  const current = String(currentChecklistId ?? '').trim() || null;
  const previousDefault = getDefaultChecklistIdForActivityType(activityTypes, previousType);
  const nextDefault = getDefaultChecklistIdForActivityType(activityTypes, nextType);
  if (!current || current === previousDefault) return nextDefault;
  return current;
}
